import { fromZonedTime, toZonedTime, formatInTimeZone } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export function toUTC(dateInput, zone) {
  if (typeof dateInput === 'string') {
    const iso = parseISO(dateInput);
    if (!Number.isNaN(iso.getTime())) return iso;
  }
  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  return new Date(d.toISOString());
}

export function localWallTimeToUTC(localIsoOrParts, userIana) {
  return fromZonedTime(localIsoOrParts, userIana);
}

export function utcToLocal(utcDate, userIana) {
  const d = typeof utcDate === 'string' ? parseISO(utcDate) : utcDate;
  return toZonedTime(d, userIana);
}

export function formatLocal(utcOrLocal, userIana, pattern = 'yyyy-MM-dd HH:mm') {
  return formatInTimeZone(utcOrLocal, userIana, pattern);
}

const MONTH_LABELS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const formatDateParts = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export function toDateInputValue(value) {
  if (value === null || value === undefined) {
    return '';
  }

  if (value instanceof Date) {
    return formatDateParts(value);
  }

  if (typeof value === 'number') {
    return formatDateParts(new Date(value));
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return '';
    }

    const isoMatch = /^([0-9]{4})-([0-9]{2})-([0-9]{2})/.exec(trimmed);
    if (isoMatch) {
      const [, year, month, day] = isoMatch;
      return `${year}-${month}-${day}`;
    }

    try {
      const parsed = parseISO(trimmed);
      const formatted = formatDateParts(parsed);
      if (formatted) {
        return formatted;
      }
    } catch (err) {
      // Ignore parsing errors and attempt a generic Date parse below.
    }

    const fallback = new Date(trimmed);
    return formatDateParts(fallback);
  }

  return '';
}

export function formatDateDdMmmYyyy(value, fallback = '—') {
  const normalised = toDateInputValue(value);
  if (!normalised) {
    return fallback;
  }

  const parts = normalised.split('-');
  if (parts.length !== 3) {
    return fallback;
  }

  const [year, month, day] = parts;
  const monthIndex = Number(month) - 1;
  const monthLabel = MONTH_LABELS[monthIndex];

  if (!monthLabel) {
    return fallback;
  }

  return `${day}-${monthLabel}-${year}`;
}

